import { r as c, A as a } from "./analytics-client-BKLFpCLd.js";
import { i as S, p as N } from "./analytics-client-BKLFpCLd.js";
import i from "posthog-js";
import { TeacherTotter as p } from "@3plearning/teacher-totter";
function u(n, t) {
  return `mx.${n}.${t}`;
}
class d {
  constructor(t) {
    this.config = t, this.name = "posthog", this.isGroupGated = !0, this.initialised = !1;
  }
  init() {
    this.initialised || (i.init(this.config.apiKey, { api_host: this.config.host, defaults: "2026-01-30" }), this.initialised = !0);
  }
  identify(t, e) {
    i.identify(t, e);
  }
  setCommonProps() {
  }
  track(t) {
    i.capture(u(t.commonProps.mx_app, t.name), {
      ...t.commonProps,
      ...t.props
    });
  }
  shutdown() {
    i.reset();
  }
}
const h = "https://us.i.posthog.com", l = "phc_9yc5ytpVb7nmZTvJUBSqbMjvNQnge59n4l7VLddsxFA";
class f {
  constructor(t) {
    this.config = t, this.name = "teacher-totter", this.isGroupGated = !1, this.instance = null;
  }
  init() {
    this.instance || (this.instance = new p({
      application: { name: this.config.product },
      options: {
        syncOptions: {
          syncUrl: this.config.syncUrl,
          getAuthCallback: async () => await this.config.getAuthToken?.() ?? void 0
        }
      }
    }));
  }
  identify() {
  }
  setCommonProps() {
  }
  track(t) {
    this.instance?.sendEvent(t.name, this.config.product, t.props);
  }
  trackSession(t) {
    this.instance?.trackSession(t, this.config.product);
  }
  shutdown() {
    this.instance = null;
  }
}
function m(n) {
  const t = [], { posthog: e, teacherTotter: o } = n.providers;
  return e?.enabled && t.push(
    new d({
      apiKey: e.apiKey ?? l,
      host: e.host ?? h
    })
  ), o?.enabled && t.push(
    new f({
      syncUrl: o.syncUrl,
      product: o.product,
      getAuthToken: o.getAuthToken
    })
  ), t;
}
function v(n) {
  const t = c(n);
  return new a(t, m(t));
}
const g = /^[a-z0-9]+(\.[a-z0-9-]+)+$/;
function T(n) {
  for (const t of Object.keys(n))
    if (!g.test(t))
      throw new Error(`[analytics] Invalid event name "${t}". Expected domain.action, e.g. "assignment.confirmed".`);
  return n;
}
const P = T({
  "page.view": { group: "core", props: {} },
  "page.time-on-page": { group: "core", props: {} },
  "section.error": { group: "core", props: {} }
}), y = "/create-jwt-token";
async function E(n, t) {
  const e = await fetch(`${n}${y}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ authToken: t })
  });
  if (!e.ok) return;
  const o = await e.json();
  if (!(!o.success || !o.token))
    return o.token;
}
function _({
  identityGatewayUrl: n,
  getAppAuthToken: t
}) {
  let e, o = null;
  return async () => {
    const s = t();
    if (!(!s || !n))
      return e || (o || (o = E(n, s).then((r) => (r || console.warn("[analytics] Identity JWT response did not include a token."), e = r, e)).catch(() => {
        console.warn("[analytics] Identity JWT request failed.");
      }).finally(() => {
        o = null;
      })), o);
  };
}
export {
  P as SHARED_EVENTS,
  v as createAnalytics,
  _ as createIdentityJwtTokenGetter,
  T as defineEvents,
  S as isFeatureEnabled,
  N as parseEnabledGroups
};



// WEBPACK FOOTER //
// ./~/@3plearning/mx-teacher-analytics/dist/analytics.js